import { useQuery } from '@tanstack/react-query';
import { tripPlanApi } from '@/api/tripPlan';

export function useMyTripPlan() {
  return useQuery({
    queryKey: ['trip-plan', 'mine'],
    queryFn: () => tripPlanApi.getMyActivePlan(),
  });
}
